/* Creepy Cute theme — vanilla JS, no dependencies. Uses Shopify AJAX Cart API + Section Rendering API. */
(function () {
  'use strict';
  var CC = window.CC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || CC.moneyFormat || '${{amount}}';
    function fmt(n, d, ts, ds) {
      d = d == null ? 2 : d; ts = ts || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (parts[1] ? ds + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  CC.formatMoney = formatMoney;

  /* ---------- overlays ---------- */
  function scrim(on) { var s = $('[data-scrim]'); if (s) s.classList.toggle('on', on); document.body.classList.toggle('lock', on); }
  function openDrawer() {
    if (CC.cartType === 'page') { window.location.href = CC.routes.cart_url; return; }
    var d = $('#CartDrawer'); if (!d) { window.location.href = CC.routes.cart_url; return; }
    closeMenu(); d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); scrim(true);
    var c = $('[data-close-cart]', d); if (c) c.focus();
  }
  function closeDrawer() { var d = $('#CartDrawer'); if (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); } }
  function openMenu() { var m = $('#MobileMenu'); if (!m) return; m.classList.add('on'); m.setAttribute('aria-hidden', 'false'); scrim(true); }
  function closeMenu() { var m = $('#MobileMenu'); if (m) { m.classList.remove('on'); m.setAttribute('aria-hidden', 'true'); } }
  function closeAll() { closeDrawer(); closeMenu(); scrim(false); }
  CC.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-cart]')) { if (CC.cartType !== 'page' && $('#CartDrawer')) { e.preventDefault(); openDrawer(); } return; }
    if (t.closest('[data-close-cart]') || t.closest('[data-scrim]') || t.closest('[data-close-menu]')) { e.preventDefault(); closeAll(); return; }
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openMenu(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart ---------- */
  var SECTION = 'cart-drawer';
  function isCartPage() { return document.body.classList.contains('template-cart'); }

  function renderDrawer(sections) {
    if (!sections || !sections[SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var fresh = doc.querySelector('#CartDrawerInner');
    var cur = $('#CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var count = fresh ? fresh.getAttribute('data-count') : null;
    if (count !== null) {
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === '0'; });
    }
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
  }

  function busy(on) { var d = $('#CartDrawer'); if (d) d.classList.toggle('busy', on); }

  function addItems(items, btn, errEl) {
    if (btn) btn.classList.add('loading');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    return fetch(CC.routes.cart_add_url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: [SECTION], sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('loading');
        if (!res.ok || res.j.status) {
          var msg = res.j.description || res.j.message || 'Could not add to cart. Please try again.';
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else { window.console && console.warn(msg); }
          return false;
        }
        if (CC.cartType === 'page' || !$('#CartDrawer')) { window.location.href = CC.routes.cart_url; return true; }
        if (isCartPage()) { window.location.reload(); return true; }
        renderDrawer(res.j.sections);
        openDrawer();
        return true;
      }).catch(function () {
        if (btn) btn.classList.remove('loading');
        if (errEl) { errEl.textContent = 'Connection problem. Please try again.'; errEl.hidden = false; }
      });
  }
  CC.addItems = addItems;

  function changeLine(line, qty) {
    busy(true);
    return fetch(CC.routes.cart_change_url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: [SECTION], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      busy(false);
      if (isCartPage()) { window.location.reload(); return; }
      if (j.status) { refreshDrawer(); return; }
      renderDrawer(j.sections);
    }).catch(function () { busy(false); });
  }

  // product forms (product page, cards with a form)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-form]');
    if (!form) return;
    if (CC.cartType === 'page') return; // let Shopify handle the POST
    e.preventDefault();
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;
    var qEl = form.querySelector('[name="quantity"]');
    var q = Math.max(1, parseInt(qEl ? qEl.value : 1, 10) || 1);
    var item = { id: Number(idEl.value), quantity: q };
    var props = {};
    $$('[name^="properties["]', form).forEach(function (p) { props[p.name.slice(11, -1)] = p.value; });
    if (Object.keys(props).length) item.properties = props;
    var sp = form.querySelector('[name="selling_plan"]'); if (sp && sp.value) item.selling_plan = sp.value;
    addItems([item], form.querySelector('[type="submit"]'), form.querySelector('[data-form-error]') || $('[data-form-error]', form.closest('section') || document));
  });

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addItems([{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }], qa); return; }
    var ch = e.target.closest('[data-line]');
    if (ch) { e.preventDefault(); changeLine(Number(ch.getAttribute('data-line')), Number(ch.getAttribute('data-qty'))); return; }
    var all = e.target.closest('[data-add-selected]');
    if (all) {
      e.preventDefault();
      var box = all.closest('[data-recs]') || document;
      var items = $$('input[data-variant]:checked', box).map(function (i) { return { id: Number(i.getAttribute('data-variant')), quantity: 1 }; });
      if (all.hasAttribute('data-include-main')) {
        var mainId = $('form[data-product-form] [name="id"]');
        if (mainId && mainId.value) items.unshift({ id: Number(mainId.value), quantity: 1 });
      }
      if (items.length) addItems(items, all);
    }
  });

  /* ---------- small widgets ---------- */
  function initAnnouncement() {
    $$('[data-ann]').forEach(function (bar) {
      var msgs = $$('[data-msg]', bar); if (msgs.length < 2) return;
      var i = 0, speed = Number(bar.getAttribute('data-speed') || 4) * 1000;
      setInterval(function () {
        msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false;
        msgs[i].style.animation = 'none'; void msgs[i].offsetWidth; msgs[i].style.animation = '';
      }, speed);
    });
  }

  function initBeforeAfter(root) {
    $$('[data-ba]', root).forEach(function (ba) {
      var r = $('input[type=range]', ba); if (!r || r._b) return; r._b = 1;
      r.addEventListener('input', function () { ba.style.setProperty('--x', r.value + '%'); });
    });
  }

  function initCountdown(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      var now = new Date();
      var m = Number(el.getAttribute('data-month') || 10) - 1, d = Number(el.getAttribute('data-day') || 31);
      var target = new Date(now.getFullYear(), m, d);
      if (target - now < -864e5) target = new Date(now.getFullYear() + 1, m, d);
      var days = Math.max(0, Math.ceil((target - now) / 864e5));
      var n = $('[data-days]', el); if (n) n.textContent = days;
      var lbl = $('[data-days-label]', el); if (lbl && days === 1) lbl.innerHTML = 'day<br>to go';
    });
  }

  function addBusinessDays(date, n) {
    var d = new Date(date); var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  function initEta(root) {
    $$('[data-eta]', root).forEach(function (el) {
      var a = addBusinessDays(new Date(), Number(el.getAttribute('data-min') || 5));
      var b = addBusinessDays(new Date(), Number(el.getAttribute('data-max') || 9));
      var f = function (x) { return x.toLocaleDateString(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' }); };
      el.textContent = f(a) + ' – ' + f(b);
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (sec) {
      if (sec._i) return; sec._i = 1;
      var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var form = $('form[data-product-form]', sec);
      var idInput = $('[name="id"]', form);
      var qtyInput = $('[name="quantity"]', form);
      var atc = $('[data-atc]', sec);
      var atcLabel = $('[data-atc-label]', sec);
      var sticky = $('[data-sticky]', sec);
      var stickyBtn = sticky ? $('button', sticky) : null;
      var current = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];

      function selectedOptions() {
        return $$('[data-option]', sec).map(function (fs) {
          var c = $('input:checked', fs); var s = $('select', fs);
          return c ? c.value : (s ? s.value : null);
        });
      }
      function offerPct() {
        var o = $('input[name="cc-offer"]:checked', sec);
        return o ? Number(o.getAttribute('data-pct') || 0) : 0;
      }
      function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }

      function updateOffers() {
        $$('[data-offer]', sec).forEach(function (lab) {
          var q = Number(lab.getAttribute('data-q')), pct = Number(lab.getAttribute('data-pct'));
          var full = current.price * q, now = Math.round(full * (1 - pct / 100));
          var p = $('[data-offer-price]', lab); if (p) p.textContent = formatMoney(now);
          var s = $('[data-offer-compare]', lab);
          if (s) {
            var cmp = Math.max(full, (current.compare_at_price || 0) * q);
            s.textContent = cmp > now ? formatMoney(cmp) : '';
          }
        });
      }

      function updateButtons() {
        var q = qty(), pct = offerPct();
        var total = Math.round(current.price * q * (1 - pct / 100));
        var label;
        if (!current.available) label = 'Sold out';
        else label = 'Add to cart · ' + formatMoney(total);
        if (atcLabel) atcLabel.textContent = label;
        if (atc) atc.disabled = !current.available;
        if (stickyBtn) { stickyBtn.textContent = current.available ? 'Add · ' + formatMoney(total) : 'Sold out'; stickyBtn.disabled = !current.available; }
      }

      function updateVariant() {
        var opts = selectedOptions();
        if (opts.length) {
          var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          current = v || null;
        }
        if (!current) {
          if (atcLabel) atcLabel.textContent = 'Unavailable';
          if (atc) atc.disabled = true;
          return;
        }
        idInput.value = current.id;
        var pr = $('[data-price]', sec);
        if (pr) {
          var h = '<span>' + formatMoney(current.price) + '</span>';
          if (current.compare_at_price > current.price) {
            h += ' <s>' + formatMoney(current.compare_at_price) + '</s> <span class="save">Save ' + formatMoney(current.compare_at_price - current.price) + '</span>';
          }
          pr.innerHTML = h;
        }
        var st = $('[data-stock]', sec);
        if (st) {
          var dot = $('.dot', st), txt = $('[data-stock-text]', st);
          if (dot) dot.classList.toggle('out', !current.available);
          if (txt) txt.textContent = current.available ? 'In stock' : 'Sold out';
        }
        // availability on option buttons (relative to other selections)
        $$('[data-option]', sec).forEach(function (fs, idx) {
          $$('input', fs).forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var ok = product.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
            var l = inp.nextElementSibling; if (l) l.classList.toggle('na', !ok);
          });
          var lg = $('[data-option-value]', fs); if (lg) lg.textContent = opts[idx];
        });
        if (current.featured_media) goToMedia(current.featured_media.id);
        if (history.replaceState && $$('[data-option]', sec).length) {
          var url = new URL(window.location.href); url.searchParams.set('variant', current.id);
          history.replaceState({}, '', url.toString());
        }
        updateOffers(); updateButtons();
      }

      // gallery
      var slides = $('[data-slides]', sec);
      function goToMedia(id) {
        if (!slides) return;
        var s = $('[data-media-id="' + id + '"]', slides); if (!s) return;
        slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      }
      if (slides) {
        var dots = $$('[data-dots] i', sec), thumbs = $$('[data-thumb]', sec);
        var onScroll = function () {
          var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
          dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
          thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
        };
        slides.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { goToMedia(t.getAttribute('data-thumb')); }); });
      }

      $$('[data-option] input, [data-option] select', sec).forEach(function (i) { i.addEventListener('change', updateVariant); });
      $$('input[name="cc-offer"]', sec).forEach(function (o) {
        o.addEventListener('change', function () { qtyInput.value = o.value; updateButtons(); });
      });
      $$('[data-qty-btn]', sec).forEach(function (b) {
        b.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() + Number(b.getAttribute('data-qty-btn'))); updateButtons(); });
      });
      qtyInput.addEventListener('change', updateButtons);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
      if (sticky && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0]; sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(atc);
      }
      updateOffers(); updateButtons();
    });
  }

  function initRecs(root) {
    $$('[data-recs][data-url]', root).forEach(function (el) {
      if (el._i) return; el._i = 1;
      var hide = function () { var sec = el.closest('.shopify-section'); if (sec) sec.hidden = true; };
      var load = function (url, next) {
        fetch(url).then(function (r) { return r.text(); }).then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var inner = doc.querySelector('[data-recs]');
          if (inner && inner.querySelector('[data-has-recs]')) { el.innerHTML = inner.innerHTML; }
          else if (next) { load(next, null); }
          else { hide(); }
        }).catch(hide);
      };
      load(el.getAttribute('data-url'), el.getAttribute('data-fallback-url'));
    });
  }

  function initAll(root) {
    initBeforeAfter(root); initCountdown(root); initEta(root); initProduct(root); initRecs(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAnnouncement(); initAll(document); });
  // theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-ann]'); if (slide) { $$('[data-msg]', slide).forEach(function (m) { m.hidden = m !== e.target; }); }
  });
})();
